/** Leaves that belong to a `.list` sidebar entry (detail / create screens). */
const LIST_DETAIL_LEAVES = new Set(['item', 'new', 'edit', 'create', 'view'])

/**
 * Whether a sidebar leaf link should look active for the current route name.
 * Exact match, or `.list` → matching `.item` / `.new` of the same prefix
 * (e.g. users.list active on users.item, but not on users.updating).
 */
export function isSidebarRouteActive(routeName, itemName) {
  if (typeof routeName !== 'string' || typeof itemName !== 'string') {
    return false
  }
  if (routeName === itemName) {
    return true
  }

  const itemParts = itemName.split('.')
  const routeParts = routeName.split('.')
  if (itemParts.length < 2 || routeParts.length < 2) {
    return false
  }

  const itemLeaf = itemParts[itemParts.length - 1]
  const routeLeaf = routeParts[routeParts.length - 1]
  const itemPrefix = itemParts.slice(0, -1).join('.')
  const routePrefix = routeParts.slice(0, -1).join('.')

  return (
    itemLeaf === 'list' &&
    itemPrefix === routePrefix &&
    LIST_DETAIL_LEAVES.has(routeLeaf)
  )
}

/**
 * Parent folder is active when any of its sidebar children is active.
 */
export function isSidebarParentActive(routeName, childNames = []) {
  return childNames.some(name => isSidebarRouteActive(routeName, name))
}
